<headerCustom></headerCustom>
<sidebarWrapper></sidebarWrapper>

<div class="main-content">
    <div class="adduserContainer">
        <div class="pageContentWrapper">
          <div class="pageHeading">
            <div class="row">
              <div class="col-6">
                <div class="headerName">
                  <h3>Role Ladder</h3>
                </div>
              </div>
              <div class="col-6 addUserButton text-right">
                <div class="row">
                  <div class="col-12">
                    <button type="button" class="btn hvr-bounce-to-top">Add
                        Details</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="addUserButtonTableData">
            <div class="addUserFormLayout customizeRtsScrollBar addUserFormContainer">
              <div class="table-arrow">
                <img src="assets/long-arrow-up-3.png" />
              </div>
                <div class="tableWrapper">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Role Ladder</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Delivery Manager</td>
                            </tr>
                            <tr>
                                <td>Senior Project Manager</td>
                            </tr>
                            <tr>
                                <td>Project Manager</td>
                            </tr>
                            <tr>
                                <td>Associate Project Manager</td>
                            </tr>
                            <tr>
                                <td>Project  Lead</td>
                            </tr>
                            <tr>
                                <td>Associate Lead</td>
                            </tr>
                            <tr>
                                <td>Senior Software Engineer II</td>
                            </tr>
                            <tr>
                                <td>Senior Software Engineer I</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
        </div>
      </div>
</div>

<div class="loader" *ngIf="loading">
  <div class="lds-roller">
    <!-- <img src="assets/preloader.gif" />
    <span>Wait...</span> -->
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>